var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "bloco_com-fundo-branco u-margem-inferior-grande",
      attrs: { tabindex: "1" }
    },
    [
      _c("div", { staticClass: "caixa_cor-cinza-claro u-padding-media " }, [
        _c(
          "div",
          {
            staticClass:
              "grade__linha informacoes-primarias alinhamento-entre-colunas grade__linha_alinhar-vertical-centro"
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "u-margem-esquerda-pequena informacoes-primaria__texto"
              },
              [
                _c("h3", { staticClass: "titulo titulo_medio " }, [
                  _vm._v(
                    "Olá " +
                      _vm._s(
                        _vm.obterPrimeiroNome(_vm.dados.NomeDoBeneficiario)
                      )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "informacoes-primarias__numero-do-contrato" },
                  [
                    _vm._v("\n                    Seu número de contrato é "),
                    _c("strong", [_vm._v(_vm._s(_vm.dados.NumeroDoContrato))])
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "informacoes-beneficiario u-padding-media" }, [
        _c("div", { staticClass: "informacoes-beneficiario_nome" }, [
          _c("h3", { staticClass: "titulo titulo_mini" }, [
            _vm._v("Nome completo:")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "u-sem-margem" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.dados.NomeDoBeneficiario) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "informacoes-beneficiario_endereco" }, [
          _c("h3", { staticClass: "titulo titulo_mini" }, [_vm._v("CPF:")]),
          _vm._v(" "),
          _c("p", { staticClass: "u-sem-margem" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.formatarCpf(_vm.dados.Cpf)) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "informacoes-beneficiario_endereco" }, [
          _c("h3", { staticClass: "titulo titulo_mini" }, [
            _vm._v("Endereço do imóvel")
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dados.Logradouro.length > 0,
                  expression: "dados.Logradouro.length > 0"
                }
              ],
              staticClass: "u-sem-margem"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.dados.Logradouro +
                      " " +
                      (_vm.dados.QuadraELote
                        ? ", " + _vm.dados.QuadraELote
                        : "") +
                      " - BAIRRO " +
                      _vm.dados.Bairro +
                      " - " +
                      _vm.dados.Cep +
                      " - " +
                      _vm.dados.CidadeComEstado
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "informacoes-primaria__icone" }, [
      _c("i", { staticClass: "fad fa-user-alt" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-173b00c1", { render: render, staticRenderFns: staticRenderFns })
  }
}